export function sanitizeFilenameSegment(value: string): string {
  let out = ''
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i)
    const ch = value[i]
    if (
      code < 32 ||
      ch === '\\' ||
      ch === '/' ||
      ch === ':' ||
      ch === '*' ||
      ch === '?' ||
      ch === '"' ||
      ch === '<' ||
      ch === '>' ||
      ch === '|'
    ) {
      out += '_'
    } else {
      out += ch
    }
  }
  return out.trim().slice(0, 80) || 'waiver'
}
